"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DURATIONS = exports.POSITIONS = exports.buttonOverridesFromTheme = void 0;

var _componentLayerManager = require("@doordash/component-layer-manager");

var buttonOverridesFromTheme = function buttonOverridesFromTheme(theme) {
  return {
    Colors: {
      ButtonFlatPrimaryForeground: theme.Colors.ToastInformationalAction,
      ButtonFlatPrimaryForegroundDisabled: theme.Colors.ToastInformationalActionDisabled,
      ButtonFlatPrimaryForegroundHovered: theme.Colors.ToastInformationalActionHovered,
      ButtonFlatPrimaryForegroundPressed: theme.Colors.ToastInformationalActionPressed
    },
    Typography: {
      TextStyles: {
        ToastAction: theme.Typography.TextStyles.ToastAction
      }
    }
  };
};

exports.buttonOverridesFromTheme = buttonOverridesFromTheme;
var POSITIONS = {
  TopStart: _componentLayerManager.AnchoredLayer.Positions.TopLeft,
  TopCenter: _componentLayerManager.AnchoredLayer.Positions.TopCenter,
  TopEnd: _componentLayerManager.AnchoredLayer.Positions.TopRight,
  BottomStart: _componentLayerManager.AnchoredLayer.Positions.BottomLeft,
  BottomCenter: _componentLayerManager.AnchoredLayer.Positions.BottomCenter,
  BottomEnd: _componentLayerManager.AnchoredLayer.Positions.BottomRight
};
exports.POSITIONS = POSITIONS;
var DURATIONS = {
  Short: 4000,
  Medium: 6000,
  Long: 10000
};
exports.DURATIONS = DURATIONS;